import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ArrowBack = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <button
            onClick={handleBack}
            aria-label="Volver atrás"
            className="inline-flex items-center px-3 py-2 mb-2 text-sm font-medium text-white bg-[#DC3465] rounded-lg shadow-sm hover:bg-[#c02e59] transition-colors"
        >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver Atrás
        </button>

    );
};

export default ArrowBack;